import { useQuery } from '@tanstack/react-query'
import React from 'react'
import Breadcrum from '../../components/breadcrum'
import { getCartData } from '../../api/userApi'

const Cart = () => {
  const { data, isLoading, isError } = useQuery({
    querykey: ['cartData'],
    queryFn: getCartData,
  })

  console.log('cart data on page', data)

  if (isLoading) {
    return (
      <>
        <Breadcrum subheading="All user" heading="user cart" />
        <div className="flex items-center justify-center min-h-[500px]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600 font-medium">
              Loading cart data...
            </p>
          </div>
        </div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum subheading="All user" heading="user cart" />
        <div className="flex items-center justify-center min-h-[500px]">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Failed to Load cart
            </h3>
            <p className="text-gray-600">
              Unable to fetch cart data. Please try again later.
            </p>
          </div>
        </div>
      </>
    )
  }

  return <div>Cart</div>
}

export default Cart
